import { signOut } from 'next-auth/react'
import { getTargetOrg, setTargetOrg } from '@omnea-app/fe-auth/TokenProvider'

export const logOut = () => {
  const targetOrg = getTargetOrg()
  try {
    localStorage.clear()
  } catch {
    // Ignore storage errors and continue with sign out
  } finally {
    if (targetOrg) setTargetOrg(targetOrg)
    void signOut({ callbackUrl: '/login' })
  }
}
